import ModalComponent from "../Modal/Modal"
import React, { useEffect, useState } from "react"
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { BankAccountIcon, BankCardIcon } from "../Icons/Icons"
import PaymentCardViewTab from "./PaymentCardViewTab"
import PaymentBankViewTab from "./PaymentBankViewTab"
import PaymentAddressViewTab from "./PaymentAddressViewTab"
import { editBankAccountLinkById } from "../../features/bankAccountLink/bankAccountLink"
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider"
import { useDispatch } from "react-redux"
import {
  validateFormBankAccount,
  validateFormCreditCard
} from "../../containers/Contacts/add-contact/CreditSelect/helper"
import { ACH, acceptsAch, acceptsCard, defaultMethodOf } from "../../constants/paymentMethods"
import { useUiKit } from "../UiKit/UiKitContext"

const CARD_TAB = 0
const ACH_TAB = 1

const AddMethodPaymentModal = ({
  triggerUpdate,
  userId,
  userData,
  isLink = true,
  customClasses = false,
  customButton = false,
  disabled = false,
  removeOld = false,
  setTriggerMethodAdded = null,
  acceptedPaymentMethods,
  onCardSaved,
}) => {
  const [pickedTab, setPickedTab] = useState(null)
  const [address, setAddress] = useState({})
  const [triggerAddPaymentMethod, setTriggerAddPaymentMethod] = useState(false)
  const [triggerCloseModal, setTriggerCloseModal] = useState(false)
  const [fields, setFields] = useState('')
  const [errors, setErrors] = useState([])
  const { triggerLoading } = useMyContextLoading()
  const dispatch = useDispatch()
  const { button: kitButton } = useUiKit()
  const [saving, setSaving] = useState(false)

  const showCard = acceptsCard(acceptedPaymentMethods)
  const showAch = acceptsAch(acceptedPaymentMethods)
  const defaultTab = defaultMethodOf(acceptedPaymentMethods) === ACH ? ACH_TAB : CARD_TAB
  const pickedTabAccepted = (pickedTab === CARD_TAB && showCard) || (pickedTab === ACH_TAB && showAch)
  const valueTab = pickedTabAccepted ? pickedTab : defaultTab

  const handleChange = (event, newValue) => {
    setPickedTab(newValue)
  }

  const updateUserBankAccountLinkByUserId = async () => {
    triggerLoading(true)
    try {
      await dispatch(editBankAccountLinkById(userId))
    } catch (error) {
      console.error("Error dispatching editBankAccountLinkById:", error)
    }
    triggerLoading(false)
  }

  useEffect(() => {
    valueTab === CARD_TAB ? validateFormCreditCard({ fields, setErrors }) : validateFormBankAccount({ fields, setErrors })
  }, [fields])


  const [kitSave, setKitSave] = useState({ tab: null, nonce: 0 })

  const handleSaving = (active, saved) => {
    setSaving(active)
    if (!active && saved) setTriggerCloseModal(prevState => !prevState)
  }

  const triggerFor = (tab) => (kitButton
    ? (kitSave.tab === tab ? kitSave.nonce : 0)
    : valueTab === tab && triggerAddPaymentMethod)

  const tabLock = saving ? { disabled: true } : null

  const addPaymentMethod = () => {
    if (kitButton) {
      if (saving) return
      setKitSave((prev) => ({ tab: valueTab, nonce: prev.nonce + 1 }))
      setTriggerMethodAdded && setTriggerMethodAdded(true)
      return
    }
    setTriggerAddPaymentMethod(true)
    setTriggerCloseModal(prevState => !prevState)
    setTriggerMethodAdded && setTriggerMethodAdded(true)
  }

  const triggerAddPaymentToFalse = () => {
    setTriggerAddPaymentMethod(false)
    if (kitButton) setKitSave((prev) => ({ tab: null, nonce: prev.nonce }))
  }

  return (
    <ModalComponent
      modalButtonTitle="Save"
      title="Add Payment Method"
      disableCloseFunctionButton={true}
      functionButton={addPaymentMethod}
      disabled={Object.keys(errors).some((key) => errors[key]) || disabled}
      customButton={customButton ? customButton : "Add"}
      onClose={triggerAddPaymentToFalse}
      triggerCloseModal={triggerCloseModal}
      functionButtonLoading={saving}
      customClasses={customClasses ? customClasses : "w-full bg-primary-main text-white font-bold cursor-pointer text-sm hover:bg-primary-main/90 pt-2.5 pb-2.5 rounded-lg text-center p-0"}
    >
      <div
        className="flex flex-col items-start gap-6 self-stretch pt-6 pb-10 px-6 rounded-2xl border border-divider bg-paper">
        <div
          className="payment_method text-text-secondary font-sans text-xs font-bold leading-[150%] uppercase">
          Payment Method
        </div>
        <Box sx={{ maxWidth: { xs: 320, sm: 480 }, bgcolor: 'background.paper' }}>
          <Tabs
            value={valueTab}
            onChange={handleChange}
            aria-label="Tabs"
            sx={{
              '.MuiTabs-scroller': {
                height: '35px'
              },
              '.MuiTabs-flexContainer': {
                gap: '40px'
              },
              'button': {
                minHeight: 0,
                padding: 0,
                justifyContent: 'flex-start',
                fontWeight: 600,
                textTransform: 'capitalize'
              },
              'button svg': {
                marginRight: '5px'
              },
              '.Mui-selected': {
                color: 'var(--color-text-primary) !important',
              }
            }}
          >
            {showCard && (
              <Tab iconPosition="start" value={CARD_TAB}
                icon={<BankCardIcon fill={valueTab === CARD_TAB ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'} />}
                label="Credit Card" {...tabLock} />
            )}
            {showAch && (
              <Tab iconPosition="start" value={ACH_TAB}
                icon={<BankAccountIcon fill={valueTab === ACH_TAB ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'} />}
                label="ACH" {...tabLock} />
            )}
          </Tabs>
        </Box>
        {showCard && (
          <div className={`w-full ${valueTab === CARD_TAB ? '' : 'hidden'}`}>
            <PaymentCardViewTab updList={triggerUpdate} userId={userId} address={address}
              triggerUpd={triggerFor(CARD_TAB)}
              onSuccessFunc={updateUserBankAccountLinkByUserId} setFields={setFields}
              setErrors={setErrors} errors={errors} isLink={isLink} removeOld={removeOld}
              reportRefusals={Array.isArray(acceptedPaymentMethods)} onCardSaved={onCardSaved}
              {...(kitButton ? { onSaving: handleSaving } : null)} />
          </div>
        )}
        {showAch && (
          <div className={`w-full ${valueTab === ACH_TAB ? '' : 'hidden'}`}>
            <PaymentBankViewTab updList={triggerUpdate} userId={userId} address={address}
              triggerUpd={triggerFor(ACH_TAB)}
              onSuccessFunc={updateUserBankAccountLinkByUserId} setFields={setFields}
              setErrors={setErrors} isLink={isLink} removeOld={removeOld}
              {...(kitButton ? { onSaving: handleSaving } : null)} />
          </div>
        )}
      </div>
      <div
        className="flex flex-col items-start gap-6 self-stretch pt-6 pb-10 px-6 rounded-2xl border border-divider bg-paper mt-5">
        <div
          className="payment_method text-text-secondary font-sans text-xs font-bold leading-[150%] uppercase">
          Billing Info
        </div>
        <div className="w-full">
          <PaymentAddressViewTab returnAddress={setAddress} userData={userData} setFields={setFields}
            setErrors={setErrors} />
        </div>
      </div>
    </ModalComponent>
  )
}

export default AddMethodPaymentModal
